// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// const API_BASE = window.location.origin.includes("192.168")
//     ? "http://192.168.1.101:5010/api"
//     : "http://localhost:5010/api";

// // ─── THUNK 1: Create Checkout Session ────────────────────────────────────────
// export const createCheckoutSession = createAsyncThunk(
//     "booking/createCheckout",
//     async ({ tourId, tourName, priceUsd, qty, callsign, email, currency = "usd" }, { rejectWithValue }) => {
//         try {
//             const res = await fetch(`${API_BASE}/create-checkout-session`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ tourId, tourName, priceUsd, qty, callsign, email, currency }),
//             });
//             const data = await res.json();
//             if (!res.ok) return rejectWithValue(data.error || "Checkout failed.");
//             if (!data.url) return rejectWithValue("No checkout URL returned.");
//             return data;
//         } catch (err) {
//             return rejectWithValue(err.message || "Network error — please try again.");
//         }
//     }
// );

// // ─── THUNK 2: Fetch Session (success page) ───────────────────────────────────
// export const fetchCheckoutSession = createAsyncThunk(
//     "booking/fetchSession",
//     async (sessionId, { rejectWithValue }) => {
//         try {
//             const res = await fetch(`${API_BASE}/session`, {
//                 method: "POST",                                    // ← GET thi POST
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ sessionId }),             // ← body ma pass
//             });
//             const data = await res.json();
//             if (!res.ok) return rejectWithValue(data.error || "Session not found.");
//             return data;
//         } catch (err) {
//             return rejectWithValue(err.message || "Could not retrieve booking.");
//         }
//     }
// );

// // ─── SLICE ────────────────────────────────────────────────────────────────────
// const bookingSlice = createSlice({
//     name: "booking",
//     initialState: {
//         modalOpen: false,
//         selectedTour: null,
//         callsign: "",
//         email: "",
//         qty: 1,
//         currency: "usd",
//         terms: false,
//         error: null,
//         checkoutStatus: "idle",
//         checkoutError: null,
//         sessionStatus: "idle",
//         sessionData: null,
//     },

//     reducers: {
//         openModal(state, action) {
//             state.modalOpen = true;
//             state.selectedTour = action.payload;
//             state.error = null;
//             state.checkoutStatus = "idle";
//             state.checkoutError = null;
//             state.terms = false;
//             state.qty = 1;
//         },
//         closeModal(state) {
//             state.modalOpen = false;
//             state.selectedTour = null;
//             state.terms = false;
//             state.error = null;
//             state.checkoutStatus = "idle";
//             state.checkoutError = null;
//         },
//         setBookingField(state, action) {
//             const { field, value } = action.payload;
//             state[field] = value;
//             if (field !== "error") state.error = null;
//         },
//         setQty(state, action) {
//             state.qty = Math.max(1, Math.min(10, parseInt(action.payload) || 1));
//         },
//         setCurrency(state, action) {
//             state.currency = action.payload?.toLowerCase?.() ?? "usd";
//         },
//         resetSession(state) {
//             state.sessionStatus = "idle";
//             state.sessionData = null;
//         },
//     },

//     extraReducers: (builder) => {
//         builder
//             .addCase(createCheckoutSession.pending, (state) => {
//                 state.checkoutStatus = "loading";
//                 state.checkoutError = null;
//             })
//             .addCase(createCheckoutSession.fulfilled, (state) => {
//                 state.checkoutStatus = "succeeded";
//             })
//             .addCase(createCheckoutSession.rejected, (state, action) => {
//                 state.checkoutStatus = "failed";
//                 state.checkoutError = action.payload;
//             });

//         builder
//             .addCase(fetchCheckoutSession.pending, (state) => {
//                 state.sessionStatus = "loading";
//                 state.sessionData = null;
//             })
//             .addCase(fetchCheckoutSession.fulfilled, (state, action) => {
//                 state.sessionStatus = "succeeded";
//                 state.sessionData = action.payload;
//             })
//             .addCase(fetchCheckoutSession.rejected, (state) => {
//                 state.sessionStatus = "failed";
//                 state.sessionData = null;
//             });
//     },
// });

// export const {
//     openModal,
//     closeModal,
//     setBookingField,
//     setQty,
//     setCurrency,
//     resetSession,
// } = bookingSlice.actions;

// export const selectModalOpen = (s) => s.booking.modalOpen;
// export const selectSelectedTour = (s) => s.booking.selectedTour;
// export const selectBookingForm = (s) => s.booking;
// export const selectCheckoutStatus = (s) => s.booking.checkoutStatus;
// export const selectCheckoutError = (s) => s.booking.checkoutError;
// export const selectSessionData = (s) => s.booking.sessionData;
// export const selectSessionStatus = (s) => s.booking.sessionStatus;

// export default bookingSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = window.location.origin.includes("192.168")
    ? "http://192.168.1.101:5010/api"
    : "http://localhost:5010/api";

// ─── THUNK 1: Create Booking Session ─────────────────────────────────────────
// Calls our backend → backend creates pending DB record + returns FareHarbor URL
export const createCheckoutSession = createAsyncThunk(
    "booking/createCheckout",
    async ({ tourId, tourName, priceUsd, qty, callsign, email, currency = "usd" }, { rejectWithValue }) => {
        try {
            const res = await fetch(`${API_BASE}/create-checkout-session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ tourId, tourName, priceUsd, qty, callsign, email, currency }),
            });
            const data = await res.json();
            if (!res.ok) return rejectWithValue(data.error || "Booking failed.");
            if (!data.url) return rejectWithValue("No booking URL returned.");
            return data; // { url, sessionId, internalRef }
        } catch (err) {
            return rejectWithValue(err.message || "Network error — please try again.");
        }
    }
);

// ─── THUNK 2: Fetch Session (success page) ───────────────────────────────────
// After FareHarbor redirects back to /booking/success?ref={internalRef}
// we look up the booking by internalRef
export const fetchCheckoutSession = createAsyncThunk(
    "booking/fetchSession",
    async ({ sessionId, internalRef }, { rejectWithValue }) => {
        try {
            const res = await fetch(`${API_BASE}/session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ sessionId, internalRef }),
            });
            const data = await res.json();
            if (!res.ok) return rejectWithValue(data.error || "Session not found.");
            return data;
        } catch (err) {
            return rejectWithValue(err.message || "Could not retrieve booking.");
        }
    }
);

// ─── SLICE ────────────────────────────────────────────────────────────────────
const bookingSlice = createSlice({
    name: "booking",
    initialState: {
        modalOpen: false,
        selectedTour: null,
        callsign: "",
        email: "",
        qty: 1,
        currency: "usd",
        terms: false,
        error: null,
        checkoutStatus: "idle",
        checkoutError: null,
        sessionStatus: "idle",
        sessionData: null,
    },

    reducers: {
        openModal(state, action) {
            state.modalOpen = true;
            state.selectedTour = action.payload;
            state.error = null;
            state.checkoutStatus = "idle";
            state.checkoutError = null;
            state.terms = false;
            state.qty = 1;
        },
        closeModal(state) {
            state.modalOpen = false;
            state.selectedTour = null;
            state.terms = false;
            state.error = null;
            state.checkoutStatus = "idle";
            state.checkoutError = null;
        },
        setBookingField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
            if (field !== "error") state.error = null;
        },
        setQty(state, action) {
            state.qty = Math.max(1, Math.min(10, parseInt(action.payload) || 1));
        },
        setCurrency(state, action) {
            state.currency = action.payload?.toLowerCase?.() ?? "usd";
        },
        resetSession(state) {
            state.sessionStatus = "idle";
            state.sessionData = null;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(createCheckoutSession.pending, (state) => {
                state.checkoutStatus = "loading";
                state.checkoutError = null;
            })
            .addCase(createCheckoutSession.fulfilled, (state) => {
                state.checkoutStatus = "succeeded";
            })
            .addCase(createCheckoutSession.rejected, (state, action) => {
                state.checkoutStatus = "failed";
                state.checkoutError = action.payload;
            });

        builder
            .addCase(fetchCheckoutSession.pending, (state) => {
                state.sessionStatus = "loading";
                state.sessionData = null;
            })
            .addCase(fetchCheckoutSession.fulfilled, (state, action) => {
                state.sessionStatus = "succeeded";
                state.sessionData = action.payload;
            })
            .addCase(fetchCheckoutSession.rejected, (state) => {
                state.sessionStatus = "failed";
                state.sessionData = null;
            });
    },
});

export const {
    openModal,
    closeModal,
    setBookingField,
    setQty,
    setCurrency,
    resetSession,
} = bookingSlice.actions;

export const selectModalOpen      = (s) => s.booking.modalOpen;
export const selectSelectedTour   = (s) => s.booking.selectedTour;
export const selectBookingForm    = (s) => s.booking;
export const selectCheckoutStatus = (s) => s.booking.checkoutStatus;
export const selectCheckoutError  = (s) => s.booking.checkoutError;
export const selectSessionData    = (s) => s.booking.sessionData;
export const selectSessionStatus  = (s) => s.booking.sessionStatus;

export default bookingSlice.reducer;